import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { SEARCH_SVG, TIMES_SVG } from "../../../utils/svgs";
import { withDefault } from "../../../utils/withDefault";
import { AppIcon } from "../../Generic/AppIcon";

interface Props {
  placeholder?: string;
  value?: string;
  onChange: (newValue: string) => void;
  onClose: () => void;
}

const SearchModalInput = ({ value, placeholder: _placeholder, onChange, onClose }: Props) => {
  const placeholder = withDefault(_placeholder, translate(STRINGS.SEARCH));

  const InputIcon = () => {
    return value !== undefined ? (
      <AppIcon icon={TIMES_SVG} stroke="gray-300" onClick={onClose} />
    ) : (
      <AppIcon icon={SEARCH_SVG} fill="gray-300" />
    );
  };

  return (
    <div className="SearchModalInput">
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <InputIcon />
    </div>
  );
};

export default React.memo(SearchModalInput);
